import React from 'react'

export default ({ display, confirmAction, confirmText, denyAction, denyText, title, children }) => (
    <div className={`modal ${display ? 'is-active' : ''}`}>
        <div className="modal-background"></div>
        <div className="modal-card">
            <header className="modal-card-head">
                <p className="modal-card-title">{title}</p>
            </header>
            <section className="modal-card-body">{children}</section>
            <footer className="modal-card-foot">
                <button className="button is-link" onClick={confirmAction} type='button'>
                    {confirmText}
                </button>
                <button className="button" onClick={denyAction} type='button'>
                    {denyText}
                </button>
            </footer>
        </div>
    </div>
)
